import crypto from './webcrypto.js';
export default crypto.getRandomValues.bind(crypto);



// WEBPACK FOOTER //
// ./~/jose/dist/browser/runtime/random.js